import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { useRevalidator } from 'react-router-dom';
import { useInfiniteQuery } from '@tanstack/react-query';
import { Spinner, Button } from '@nike/eds';
import RecommendConceptsClient from '../../clientAPI/recommendConcepts';
import { QUERY_KEYS } from '../../constants';
import ConceptView from './ConceptView';

export default function RecommendConceptsSearchByTermsView({
  searchTerms,
}: {
  searchTerms: string;
}) {
  const revalidator = useRevalidator();
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status,
  } = useInfiniteQuery({
    queryKey: [QUERY_KEYS.RECOMMEND_CONCEPT_BY_TERMS, searchTerms],
    queryFn: async ({ pageParam }) => {
      if (pageParam) {
        return RecommendConceptsClient.next(pageParam);
      } else {
        return RecommendConceptsClient.searchAllConcepts(searchTerms);
      }
    },
    getNextPageParam: (lastPage, pages) => lastPage.pages.next,
    staleTime: Infinity,
    suspense: true,
    onError: (err: { status: number }) =>
      err.status === 401 && revalidator.revalidate(),
  });
  return (
    <div>
      <ul>
        {data &&
          data.pages.map((page) => (
            <Fragment
              key={
                page.pages.next
                  ? page.pages.next
                  : 'search_concept_viewer_page_1'
              }
            >
              {page.objects.map((rw, idx) => {
                const id = `search_concept_viewer_${rw.id}`;
                const key = `search-${rw.id}`;
                return (
                  <li key={key}>
                    <ConceptView id={id} data={rw} loadChildren={false} />
                  </li>
                );
              })}
            </Fragment>
          ))}
        {hasNextPage ? (
          <li className='tw-ml-8' key={`search_concept_viewer_bottom`}>
            <Button
              variant='ghost'
              onClick={() => fetchNextPage()}
              disabled={isFetchingNextPage}
            >
              <span className='eds-color--grey-1 tw-italic'>Load more</span>
            </Button>
            {isFetchingNextPage ? (
              <Spinner className='tw-ml-12 tw-my-2' />
            ) : null}
          </li>
        ) : null}
      </ul>
    </div>
  );
}

RecommendConceptsSearchByTermsView.propTypes = {
  searchTerms: PropTypes.string,
};
